import { useMutation, useQuery, useQueryClient } from "react-query";

import { ShopGroup, UserCreate } from "../../../utils/types";
import client, { get_all_roles, get_all_shop_groups, get_all_users } from "../../Client";

export type ShopGroupCreate = {
    name: string;
    shop_ids: string[] | [];
};

export const useShopGroupsQuery = () => {
    const { data, isLoading: shopGroupsLoading } = useQuery<ShopGroup[]>("shopGroups", get_all_shop_groups);

    return { shopGroups: data ?? [], shopGroupsLoading };
};

export const deleteShopGroup = async (id: string) => {
    return client.delete(`/v1/shop-groups/${id}`);
};

export const useAddShopGroupMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (payload: ShopGroupCreate) => {
            return client.post("/v1/shop-groups", payload);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("shopGroups");
            },
        }
    );
};

export const useDeleteShopGroupMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (id: string) => {
            return client.delete(`/v1/shop-groups/${id}`);
        },
        {
            onSuccess: () => {
                // Invalidate the shopGroups query to refetch the data
                queryClient.invalidateQueries("shopGroups");
                queryClient.invalidateQueries("users");
            },
        }
    );
};

export const useUsersQuery = () => {
    const { data: users } = useQuery("users", get_all_users);
    return { users: users ?? [] };
};

export const useRolesQuery = () => {
    const { data, isLoading: rolesLoading } = useQuery("roles", get_all_roles);
    return { roles: data ?? [], rolesLoading };
};

export const useUpdateUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (payload: UserCreate) => {
            return client.put(`/v1/users/${payload.id}`, payload);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("users");
            },
        }
    );
};
